import React from 'react';
import { View, Text } from 'react-native';
import { VictoryBar, VictoryChart, VictoryAxis } from 'victory';

type Props = { data: Array<{ date: string; totalKwh: number }>; width?: number | string; height?: number; title?: string | null };
export default function DailyKwhBarChart({ data = [], width = '100%', height = 220, title = null }: Props) {
  const chartData = React.useMemo(() => data.map((d, i) => ({ 
    x: i, 
    label: (d.date || '').slice(5),
    y: Number(d.totalKwh) || 0 
  })), [data]);
  
  // Calculate evenly spaced tick values (similar to native version)
  const tickCount = Math.min(4, Math.max(1, chartData.length));
  const xTickValues = React.useMemo(() => {
    const n = chartData.length;
    if (n === 0) return [];
    if (n <= tickCount) return Array.from({ length: n }, (_, i) => i);
    const last = n - 1;
    if (tickCount === 1) return [Math.round(last / 2)];
    const steps = tickCount - 1;
    return Array.from({ length: tickCount }, (_, i) => Math.round((i * last) / steps));
  }, [chartData.length, tickCount]);
  
  return (
    <View style={{ width: width as any, height }}>
      {title ? <Text style={{ color: 'white', fontWeight: '600', marginBottom: 8 }}>{title}</Text> : null}
      <VictoryChart 
        padding={{ top: 20, left: 50, right: 30, bottom: 30 }}
        domainPadding={{ x: 30, y: 20 }}
        style={{
          background: { fill: '#1D2025' },
          parent: { borderRadius: 10 }
        }}
      >
        <VictoryAxis 
          tickValues={xTickValues}
          tickFormat={(t) => {
            const idx = Math.round(t);
            return chartData[idx] ? chartData[idx].label : '';
          }}
          style={{ 
            axis: { stroke: 'rgba(255,255,255,0.12)', strokeWidth: 1 },
            tickLabels: { fill: '#FFFFFF', fontSize: 10 },
            grid: { stroke: 'none' }
          }} 
        />
        <VictoryAxis 
          dependentAxis 
          style={{ 
            axis: { stroke: 'rgba(255,255,255,0.12)', strokeWidth: 1 },
            tickLabels: { fill: '#FFFFFF', fontSize: 10 },
            grid: { stroke: 'none' }
          }}
        />
        <VictoryBar 
          data={chartData} 
          barRatio={0.6}
          labels={() => null}
          style={{ 
            data: { 
              fill: '#39BEB7'
            },
            labels: { fill: 'transparent' }
          }}
          cornerRadius={{ top: 8 }}
          animate={{
            duration: 500,
            onLoad: { duration: 500 }
          }}
        />
      </VictoryChart>
    </View>
  );
}


